import {API} from "@/middlewares/api";
import {createAsyncThunk} from "@reduxjs/toolkit";

export const loadOrders = createAsyncThunk(
  "orders/loadOrders",
  async ({userId, mustValidateToken = true}, thunkAPI) => {
    try {
      const response = await API(`secure/v3/orders/load-orders/${userId}`, {
        method: "GET",
        mustValidateToken,
      });

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Failed to load orders");
    }
  },
);

export const checkCustomerOrders = createAsyncThunk("orders/checkCustomerOrders", async (userId, thunkAPI) => {
  try {
    const response = await API(`secure/v3/orders/load-orders/${userId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadLastOrderDate = createAsyncThunk("orders/loadLastOrderDate", async (userId, thunkAPI) => {
  try {
    const response = await API(`secure/orders/last-test/${userId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updateBloodSampleSent = createAsyncThunk("orders/updateBloodSampleSent", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/orders/update-order-blood-sent", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updateRating = createAsyncThunk("orders/updateRating", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/v2/results/update-rating", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getReceipt = createAsyncThunk("orders/getReceipt", async (orderId, thunkAPI) => {
  try {
    const response = await API(`secure/orders/get-receipt/${orderId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updateQuestionnaireStatus = createAsyncThunk(
  "orders/updateQuestionnaireStatus",
  async (payload, thunkAPI) => {
    try {
      const response = await API("secure/orders/update-questionnaire-status", {method: "POST", body: payload});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const loadClientSecret = createAsyncThunk("orders/loadClientSecret", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/v2/orders/load-client", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const requestReplacementKit = createAsyncThunk("orders/requestReplacementKit", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/v2/orders/replacement-kit", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const requestChangeAppointmentType = createAsyncThunk(
  "orders/requestChangeAppointmentType",
  async (payload, thunkAPI) => {
    try {
      const response = await API("secure/orders/phlebotomy", {method: "POST", body: payload});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const requestCancelOrder = createAsyncThunk("orders/requestCancelOrder", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/v2/orders/cancel", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const createNewTest = createAsyncThunk("orders/createNewTest", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/create-test", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updateViewStatus = createAsyncThunk("orders/updateViewStatus", async (orderId, thunkAPI) => {
  try {
    const response = await API(`secure/orders/update-view-status/${orderId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const createConsultation = createAsyncThunk("orders/createConsultation", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/v2/orders/create-consultation", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadPreBookOrders = createAsyncThunk("orders/loadPreBookOrders", async (payload, thunkAPI) => {
  let userId, mustValidateToken;

  if (typeof payload === "object") {
    userId = payload.userId;
    mustValidateToken = payload.mustValidateToken;
  } else {
    userId = payload;
  }

  try {
    const response = await API(`secure/orders/load-pre-book/${userId}`, {method: "GET", mustValidateToken});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const checkPreBookOrders = createAsyncThunk("orders/checkPreBookOrders", async (userId, thunkAPI) => {
  try {
    const response = await API(`secure/orders/load-pre-book/${userId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const savePhlebotomyAppointment = createAsyncThunk(
  "orders/savePhlebotomyAppointment",
  async (payload, thunkAPI) => {
    try {
      const response = await API("orders/save-phlebotomy-appointment", {method: "POST", body: payload});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const updatePhlebotomyAppointment = createAsyncThunk(
  "orders/updatePhlebotomyAppointment",
  async (payload, thunkAPI) => {
    try {
      const response = await API("orders/update-phlebotomy-appointment", {
        method: "POST",
        body: payload,
      });

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const checkBookingToken = createAsyncThunk("/checkBookingToken", async (bookingToken, thunkAPI) => {
  try {
    const response = await API(`/orders/check-token/${bookingToken}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getOrderById = createAsyncThunk("orders/getOrderById", async (orderId, thunkAPI) => {
  try {
    const response = await API(`secure/v2/orders/get-order/${orderId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const generateClinicUrl = createAsyncThunk("orders/generateClinicUrl", async (orderId, thunkAPI) => {
  try {
    const response = await API(`/generate-clinic-link/${orderId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getBannerSettings = createAsyncThunk("orders/getBannerSettings", async (orderId, thunkAPI) => {
  try {
    const response = await API("/orders/get-banners-settings");

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});
